import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import config from 'core/modules/EmailUnsubscribe/configs';
import Form from './components/Form';
import Canceled from './components/Canceled';
import Error from './components/Error';

import './EmailUnsubscribe.scss';

const { components: { Confirmed } } = config;

function EmailUnsubscribe() {
  const data = window.emailUnsubscribe;

  if (!data) return null;

  const {
    memberIdParam, propertyMatch, isFavoriteUnsubscribe, action,
  } = data;

  const isInvalidData = memberIdParam === '' || (propertyMatch !== '1' && isFavoriteUnsubscribe !== '1');

  if (isInvalidData) return <Error data={data} />;

  if (action === 'Confirm') return <Confirmed config={config} data={data} />;

  if (action === 'Cancel') return <Canceled data={data} />;

  return <Form data={data} />;
}

export default (props) => <ComponentErrorBoundary><EmailUnsubscribe {...props} /></ComponentErrorBoundary>;
